import React from 'react';
import Helmet from 'react-helmet';
import objectPath from 'object-path';
import apiData from 'Lib/apiData';
import cmsData from 'Lib/cmsData';
import FourOhFour from '../../components/four-oh-four';
import UnstyledList from '../../components/unstyled-list';
import DetailHero from '../../components/details/detail-hero';
import DetailStatus from '../../components/details/detail-status';
import DetailOverview from '../../components/details/detail-overview';
import DetailStart from '../../components/details/detail-start';
import InlineLink from '../../components/inline-link';

export default class CourierDetail extends React.PureComponent {

  static async getInitialProps({ query }) {
    const { id } = query;

    const contentParams = {
      content_type: 'projectDetailsImageGrid',
      'fields.projectType': 'courier',
    };

    const [courier, imageGroup] = await Promise.all([
      apiData(`/v1/couriers/${id}`),
      cmsData(contentParams),
    ]);

    return { courier, id, imageGroup: imageGroup && imageGroup[0] };
  }

  formatStats = (stats) => {
    const rawFunds = (stats.fundsRaised && stats.fundsRaised.raw) || 0;
    const rawGoal = (stats.fields.goal && stats.fields.goal.raw) || 0;

    return [
      {
        value: `${Math.floor(rawFunds / 50)} / ${rawGoal / 50}`,
        title: 'Filters Raised',
      },
      {
        value: rawFunds >= rawGoal ? '0' : (rawGoal / 50) - Math.floor(rawFunds / 50),
        title: 'Remaining to Goal',
      },
      {
        value: `${Math.round((rawFunds / rawGoal) * 100)}%`,
        title: 'Percent Funded',
      },
    ];
  };

  render() {
    const { courier, imageGroup } = this.props;

    if (courier.success && courier.message) return <FourOhFour statusCode={404} />;

    const metaDescription = courier.fields.description.substring(0, 199);
    const featuredImage = objectPath.get(courier, 'fields.featuredImage.photo.file.url');
    const ogImage = {
      fb: featuredImage ? `https:${featuredImage}?w=1200&h=630&fit=thumb` : `${process.env.S3_ROOT}/w4w-static/images/w4w-fb.png`,
      twitter: featuredImage ? `https:${featuredImage}?w=1200&h=600&fit=thumb` : `${process.env.S3_ROOT}/w4w-static/images/w4w-tw.png`,
    };

    return (
      <main>
        <Helmet>
          <title>{courier.title}</title>
          <meta property="og:title" content={courier.title} />
          <meta name="twitter:title" content={courier.title} />
          {ogImage && <meta property="og:image" content={ogImage.fb} />}
          {ogImage && <meta name="twitter:image" content={ogImage.twitter} />}
          <meta name="description" content={metaDescription} />
          <meta property="og:description" content={metaDescription} />
          <meta name="twitter:description" content={metaDescription} />
        </Helmet>

        <DetailHero
          title="Support a Courier"
          subheading={courier.title}
          image={courier.fields.featuredImage}
          isDark
          icon="courier"
          fill="#4d6c77"
          rotateIcon
        >
          <UnstyledList>
            {courier.destinationDetails &&
              <li>Location: {courier.destinationDetails.destination}</li>
            }

            {courier.creator &&
              <li>
                Organizer: <InlineLink href={`/users/${courier.creator.id}`}>{courier.creator.firstName} {courier.creator.lastName}</InlineLink>
              </li>
            }
          </UnstyledList>
        </DetailHero>

        <DetailStatus
          title="Program Status"
          stats={this.formatStats(courier)}
          isDark
          waveColor="#073342"
          id={this.props.id}
          showDonation={courier.status === 'published'}
        />
        <DetailOverview
          sectionTitle="Project Overview"
          projectTitle={courier.title}
          content={courier.fields.description}
          buttonLink={courier.acceptContact ? `mailTo:${courier.creator.email}` : undefined}
          slug={courier.slug}
          isLight
        />
        <DetailStart
          content={imageGroup.fields}
          isDark
          icon="courier"
          fill="#fff"
        />
      </main>
    );
  }
}
